import React from "react"
import _ from "lodash"
import {
  useTheme,
  Avatar,
  ListItemButton,
  Box,
  Stack,
  StackProps,
  Link,
} from "@mui/material"

export interface IAppNavigationBarOption {
  logo: string
  url: string
}

export interface IAppNavigationBarProps extends StackProps {
  navigations?: IAppNavigationBarOption[]
}

export const AppNavigationBar: React.FC<IAppNavigationBarProps> = ({
  navigations = [],
}) => {
  const theme = useTheme()

  const { root, buttonWrapper, button, icon } =
    theme.components[`AppNavigationBar`]?.styleOverrides || {}

  if (navigations.length === 0) return null

  return (
    <Stack direction="row" sx={root}>
      {navigations.map((navigation, index) => {
        const logo = _.get(navigation, "logo", "")
        const url = _.get(navigation, "url", "")
        return (
          <Box key={`AppNavigationBarBar-${index}`} sx={buttonWrapper}>
            <ListItemButton
              component={Link}
              href={url}
              target="_blank"
              sx={button}
            >
              <Avatar alt="logo" src={logo} sx={icon} />
            </ListItemButton>
          </Box>
        )
      })}
    </Stack>
  )
}
